var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.583 17.5a9.583 9.583 0 0 1 9.583-9.584 9.583 9.583 0 0 1 9.584 9.583c0 2.718-1.13 5.17-2.95 6.916a9.55 9.55 0 0 1-6.634 2.668 9.583 9.583 0 0 1-9.583-9.584m9.583-12.084c-6.673 0-12.083 5.41-12.083 12.083 0 6.674 5.41 12.084 12.083 12.084 2.805 0 5.388-.957 7.439-2.56l5.527 5.527a1.25 1.25 0 1 0 1.768-1.768l-5.495-5.494a12.04 12.04 0 0 0 2.845-7.789c0-6.673-5.41-12.083-12.084-12.083m0 17.5c-.69 0-1.25-.56-1.25-1.25V18.75H15a1.25 1.25 0 0 1 0-2.5h2.916v-2.917a1.25 1.25 0 0 1 2.5 0v2.917h2.917a1.25 1.25 0 1 1 0 2.5h-2.917v2.916c0 .69-.56 1.25-1.25 1.25",
    clipRule: "evenodd"
  })));
};
export default SvgZoomIn;